import { z } from "zod";
export const socketIoMessageTypes = {
    auth: z.object({
        key: z.string(),
    }),
    userTrackingSubmitAction: z.object({
        action: z.string(),
    }),
    authResult: z.object({
        success: z.boolean(),
        message: z.string(),
    }),
    legacyMessage: z.object({
        payload: z.string(),
    }),
};
//# sourceMappingURL=socketio.js.map